import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/shared/abstracts/base.abstract';

import { EntityTypeEnum } from '../../../../enums/entity-type.enum';

@Component({
    selector: 'app-multi-address-container',
    templateUrl: './multi-address-container.component.html',
    styleUrls: ['./multi-address-container.component.scss'],
})
export class MultiAddressContainerComponent extends BaseComponent implements OnInit {
    @Input() public group: FormGroup;
    @Input() public preferedAddress: FormControl;

    @Output() public elementSizeModification = new EventEmitter<void>();

    public entityType = EntityTypeEnum.STUDENT;

    public radioAdress = new FormControl();

    ngOnInit(): void {
        this.setOtherAddressValidators();
        this.patchRadioWithPreferedAddress();
        this.uns = this.radioAdress.valueChanges.subscribe((value: string) => {
            if (value === 'other') {
                this.preferedAddress.patchValue(this.addressOther.value.id ? this.addressOther.value.id : 0);
                this.setOtherAddressValidators();
            } else if (value === 'parent1') {
                this.preferedAddress.patchValue(this.addressParent1.value.id);
                this.removeOtherAddressValidators();
            } else if (value === 'parent2') {
                this.preferedAddress.patchValue(this.addressParent2.value.id);
                this.removeOtherAddressValidators();
            }
            this.elementSizeModification.emit();
        });

        this.uns = this.group.valueChanges.subscribe(() => this.patchRadioWithPreferedAddress());
    }

    public patchRadioWithPreferedAddress(): void {
        if (
            (this.preferedAddress.value || this.preferedAddress.value === 0) &&
            (this.preferedAddress.value === this.addressParent1.value?.id ||
                this.preferedAddress.value === this.addressParent2.value?.id ||
                this.preferedAddress.value === this.addressOther.value?.id ||
                this.preferedAddress.value === 0)
        ) {
            if (this.preferedAddress.value === this.addressParent1.value.id) {
                this.radioAdress.patchValue('parent1');
                this.removeOtherAddressValidators();
            } else if (this.preferedAddress.value === this.addressParent2.value.id) {
                this.radioAdress.patchValue('parent2');
                this.removeOtherAddressValidators();
            } else if (this.preferedAddress.value === this.addressOther.value.id || this.preferedAddress.value === 0) {
                this.radioAdress.patchValue('other');
                this.setOtherAddressValidators();
            }
        } else {
            if (this.addressParent1.value || this.addressParent2.value) {
                this.radioAdress.patchValue('parent1');
                this.removeOtherAddressValidators();
            } else {
                this.radioAdress.patchValue('other');
                this.setOtherAddressValidators();
            }
        }
        this.elementSizeModification.emit();
    }

    public setOtherAddressValidators(): void {
        this.addressOther.setValidators(Validators.required);
        this.addressOther.updateValueAndValidity({ emitEvent: false });
    }

    public removeOtherAddressValidators(): void {
        this.addressOther.clearValidators();
        this.addressOther.updateValueAndValidity({ emitEvent: false });
    }

    public get addressParent1(): FormControl {
        return this.group.get('parent1') as FormControl;
    }

    public get addressParent2(): FormControl {
        return this.group.get('parent2') as FormControl;
    }

    public get addressOther(): FormControl {
        return this.group.get('other') as FormControl;
    }
}
